/**
 * @auth 赖传峰
 * @date 2023/2/24
 */
import {
  RoutePath,
  SupportLocale,
} from '~/types/enum'

export const localeReg = new RegExp(`/(${Object.values(SupportLocale).join('|')})`, 'i')
export default (path: RoutePath | LocalePath | string): RoutePath => path.replace(localeReg, '') as RoutePath || RoutePath.HOME
